import React from 'react'
import { icons } from 'react-icons'
import { OfferDiv } from './style'
import {BsArrowRight} from 'react-icons/bs'

function Offer() {
    return (
        <OfferDiv  >
            <div className="inner-container">
                <h1 className="m-5">What we offer</h1>
                <div className="row">
                    <div className="col-md-4 arrange">
                        <h3>Medical Update</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum provident</p>
                        <div className="knowsign">
                            <p>know more <BsArrowRight /> </p> 
                        </div>
                    </div>


                    <div className="col-md-4 arrange">
                    <h3>Pharmaceuticals</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum provident</p>
                        <div className="knowsign">
                            <p>know more <BsArrowRight /> </p> 
                        </div>
                    </div>


                    <div className="col-md-4 arrange">
                    <h3>Medicals</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum provident</p>
                        <div className="knowsign">
                            <p>know more <BsArrowRight /> </p> 
                        </div>
                    </div>
                    
                </div>
            </div>
            
        </OfferDiv>
    )
}

export default Offer
